"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initFonts = exports.Fonts = void 0;
const styled_components_1 = require("styled-components");
// Inter fonts
const InterThin = require('./assets/fonts/Inter/Inter-Thin.ttf');
const InterExtraLight = require('./assets/fonts/Inter/Inter-ExtraLight.ttf');
const InterLight = require('./assets/fonts/Inter/Inter-Light.ttf');
const InterRegular = require('./assets/fonts/Inter/Inter-Regular.ttf');
const InterMedium = require('./assets/fonts/Inter/Inter-Medium.ttf');
const InterSemiBold = require('./assets/fonts/Inter/Inter-SemiBold.ttf');
const InterBold = require('./assets/fonts/Inter/Inter-Bold.ttf');
const InterExtraBold = require('./assets/fonts/Inter/Inter-ExtraBold.ttf');
const InterBlack = require('./assets/fonts/Inter/Inter-Black.ttf');
const InterItalic = require('./assets/fonts/Inter/Inter-Italic.ttf');
// Montserrat fonts
const MontserratThin = require('./assets/fonts/Montserrat/Montserrat-Thin.ttf');
const MontserratExtraLight = require('./assets/fonts/Montserrat/Montserrat-ExtraLight.ttf');
const MontserratLight = require('./assets/fonts/Montserrat/Montserrat-Light.ttf');
const MontserratRegular = require('./assets/fonts/Montserrat/Montserrat-Regular.ttf');
const MontserratMedium = require('./assets/fonts/Montserrat/Montserrat-Medium.ttf');
const MontserratSemiBold = require('./assets/fonts/Montserrat/Montserrat-SemiBold.ttf');
const MontserratBold = require('./assets/fonts/Montserrat/Montserrat-Bold.ttf');
const MontserratExtraBold = require('./assets/fonts/Montserrat/Montserrat-ExtraBold.ttf');
const MontserratBlack = require('./assets/fonts/Montserrat/Montserrat-Black.ttf');
const KomikaTitle = require('./assets/fonts/KomikaTitle/KomikaTitle.ttf');
exports.Fonts = (0, styled_components_1.createGlobalStyle) `

@font-face {
  src: url(${MontserratThin}) format('truetype');
  font-family: 'Montserrat';
  font-weight: 100;
  font-style: normal;
}


@font-face {
  src: url(${MontserratExtraLight}) format('truetype');
  font-family: 'Montserrat';
  font-weight: 200;
  font-style: normal;
}


@font-face {
  src: url(${MontserratLight}) format('truetype');
  font-family: 'Montserrat';
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Montserrat';
  src: url(${MontserratRegular}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Montserrat';
  src: url(${MontserratMedium}) format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Montserrat';
  src: url(${MontserratSemiBold}) format('truetype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Montserrat';
  src: url(${MontserratBold}) format('truetype');
  font-weight: 700;
  font-style: normal;
}


@font-face {
  font-family: 'Montserrat';
  src: url(${MontserratExtraBold}) format('truetype');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'Montserrat';
  src: url(${MontserratBlack}) format('truetype');
  font-weight: 900;
  font-style: normal;
}


@font-face {
  font-family: 'MontserratRegular';
  src: url(${MontserratRegular}) format('truetype');
}

@font-face {
  font-family: 'MontserratSemiBold';
  src: url(${MontserratSemiBold}) format('truetype');
}

@font-face {
    font-family: 'MontserratBold';
    src: url(${MontserratBold}) format('truetype');
}


@font-face {
  src: url(${InterThin}) format('truetype');
  font-family: 'Inter';
  font-weight: 100;
  font-style: normal;
}


@font-face {
  src: url(${InterExtraLight}) format('truetype');
  font-family: 'Inter';
  font-weight: 200;
  font-style: normal;
}


@font-face {
  src: url(${InterLight}) format('truetype');
  font-family: 'Inter';
  font-weight: 300;
  font-style: normal;
}

@font-face {
  font-family: 'Inter';
  src: url(${InterRegular}) format('truetype');
  font-weight: 400;
  font-style: normal;
}

@font-face {
  font-family: 'Inter';
  src: url(${InterMedium}) format('truetype');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Inter';
  src: url(${InterSemiBold}) format('truetype');
  font-weight: 600;
  font-style: normal;
}

@font-face {
  font-family: 'Inter';
  src: url(${InterBold}) format('truetype');
  font-weight: 700;
  font-style: normal;
}


@font-face {
  font-family: 'Inter';
  src: url(${InterExtraBold}) format('truetype');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: 'Inter';
  src: url(${InterBlack}) format('truetype');
  font-weight: 900;
  font-style: normal;
}


@font-face {
  font-family: 'Inter';
  src: url(${InterItalic}) format('truetype');
  font-weight: normal;
  font-style: italic;
}




@font-face {
  font-family: 'InterRegular';
  src: url(${InterRegular}) format('truetype');
}

@font-face {
  font-family: 'InterSemiBold';
  src: url(${InterSemiBold}) format('truetype');
}


@font-face {
  font-family: 'InterBold';
  src: url(${InterBold}) format('truetype');
}


@font-face {
    font-family: 'KomikaTitle';
    src: url(${KomikaTitle}) format('truetype');
}
`;
const initFonts = (onFinish) => {
    console.log("[WARNING] This function (initFonts) should only be used in native components.");
};
exports.initFonts = initFonts;
//# sourceMappingURL=fonts.js.map